module.exports = __webpack_public_path__ + "img/gem.47b3129f.svg";